export default "__VITE_ASSET__7b8acab4__"